<script lang="ts">
    import { getBorderRadius } from '$lib/global/helper/border-radius';
    import { cn } from '$lib/utils/cn';

    import { nanoid } from 'nanoid/non-secure';

    import Checkbox from './Checkbox/Checkbox.svelte';
    import Text from '../../Text/Text.View.svelte';

    export let theme: { fontColor?: string } | undefined;
    export let invalid = false;
    export let wysiwyg: Record<string, unknown> = {};
    export let finalFormInput: {
        onFocus: () => void;
        onBlur: () => void;
        onChange: (value: boolean) => void;
        value?: unknown;
    } = {
        onFocus: () => {},
        onBlur: () => {},
        onChange: () => {},
        value: undefined,
    };
    export let errorMessage = '';

    let checkboxElementContainer: HTMLDivElement | undefined;

    $: {
        // this will detect when the focusable checkbox has been focused or blurred
        // like this we can use final form input's way of detecting if the input is touched
        if (checkboxElementContainer) {
            const checkboxElements = checkboxElementContainer.getElementsByTagName('input');

            if (checkboxElements.length === 1) {
                checkboxElements[0].addEventListener('focus', finalFormInput.onFocus);
                checkboxElements[0].addEventListener('blur', finalFormInput.onBlur);
            }
        }
    }

    const handleClick = ({ detail }: CustomEvent<boolean>) => {
        finalFormInput.onFocus();
        finalFormInput.onChange(detail);
    };

    const checkboxId = `checkbox-${nanoid()}`;

    const borderRadius = getBorderRadius('fieldsWrapper');

    const wrapperClasses = cn(
        'fun-relative fun-box-border fun-flex fun-items-center fun-py-2 fun-transition-all',
        borderRadius,
    );
</script>

<div class={wrapperClasses} bind:this={checkboxElementContainer}>
    <div class="fun-relative fun-min-h-6 fun-min-w-6">
        <div class="fun-absolute fun-left-px fun-top-px fun-size-[22px] fun-rounded fun-bg-white" />

        <Checkbox
            size="24px"
            primaryColor="#0BB648"
            secondaryColor="#E5E7EB"
            checked={!!finalFormInput.value}
            on:change={handleClick}
            class="fun-absolute fun-inset-0 fun-flex-shrink-0"
            labelId={checkboxId}
        />
    </div>

    <div class="fun-flex-col">
        <label for={checkboxId}>
            <Text
                raw={wysiwyg}
                align="left"
                color={theme?.fontColor ?? '#0F0F0F'}
                openLinksInNewTab
                stopPropagationOfLinkClicks
                box={{ top: 'none', left: 'medium', right: 'medium', bottom: 'none' }}
                transitionEffect="none"
            />
        </label>

        {#if errorMessage && invalid}
            <div
                class="fun-ml-4 fun-mt-2 fun-flex fun-text-xs fun-font-normal fun-leading-tight fun-text-red-600"
            >
                {errorMessage}
            </div>
        {/if}
    </div>
</div>
